module.exports = __webpack_public_path__ + "static/media/become-instructor-thumb.1e12c6f8.png";